/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // Npm: Apollo client for handling graphql request.

/*
 * EXPORTS
 */
export default gql`
  mutation SmppMultiUpdateMutation(
    $customerId: ID!
    $customerAccountIds: [ID!]
    $smppIds: [ID!]
    $batchId: String!
    $displayName: String!
    $ip: [String!]!
    $username: String!
    $oldUsername: String!
    $password: String!
    $sessionTimeoutInterval: Float!
    $sessionAllowed: Int
    $tps: Int
    $enquireLinkInterval: Float!
    $sourceAddressTon: Int
    $sourceAddressNpi: Int
    $destinationAddressTon: Int
    $destinationAddressNpi: Int
    $trunkType: TRUNK_TYPE!
    $debuggingLevel: SMPP_DEBUGGING_LEVEL!
    $enableLossProtection: Boolean
    $chargeOnDelivered: Boolean
  ) {
    SmppMultiUpdate(
      customerId: $customerId
      batchId: $batchId
      customerAccountIds: $customerAccountIds
      smppIds: $smppIds
      displayName: $displayName
      ip: $ip
      username: $username
      oldUsername: $oldUsername
      password: $password
      sessionTimeoutInterval: $sessionTimeoutInterval
      sessionAllowed: $sessionAllowed
      tps: $tps
      enquireLinkInterval: $enquireLinkInterval
      sourceAddressTon: $sourceAddressTon
      sourceAddressNpi: $sourceAddressNpi
      destinationAddressTon: $destinationAddressTon
      destinationAddressNpi: $destinationAddressNpi
      trunkType: $trunkType
      debuggingLevel: $debuggingLevel
      enableLossProtection: $enableLossProtection
      chargeOnDelivered: $chargeOnDelivered
    ) {
      message
      data
      status
    }
  }
`;
